import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { HolidaysComponent } from './modules/attendance/holidays/holidays.component';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [


    // Redirect empty path to '/dashboards/project'
    { path: '', pathMatch: 'full', redirectTo: '/sign-in' },

    // Redirect signed-in user to the '/dashboards/project'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'attendance/attendance-punch-in' },

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'confirmation-required', loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.routes') },
            { path: 'forgot-password', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.routes') },
            { path: 'reset-password', loadChildren: () => import('app/modules/auth/reset-password/reset-password.routes') },
            { path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes') },
            { path: 'sign-up', loadChildren: () => import('app/modules/auth/sign-up/sign-up.routes') },
            { path: 'otp', loadChildren: () => import('app/modules/auth/OTP-sign/OTP-sign.routes') }
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        // canActivate: [AuthGuard],
        // canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes') },
            { path: 'unlock-session', loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.routes') },
            { path: 'email', loadChildren: () => import('app/modules/email/email.routes') },
            // passowr exppiry
            { path: 'password-update', loadChildren: () => import('app/modules/auth/update-password/update-password.routes') },

        ]
    },

    // Landing routes
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
    },

    // Admin routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,

        resolve: {
            initialData: initialDataResolver
        },
        children: [
            // finance-manager
            { path: 'finance-manager', loadChildren: () => import('app/modules/finance-manager/finance-manager-dashboard.routing') },
            { path: 'payment', loadChildren: () => import('../app/modules/finance-manager/approvals-total-amount-view/approvals-total-amount-view.routing') },
            { path: 'approvals', loadChildren: () => import('../app/modules/finance-manager/approvals/approvals.routing') },

            // Dashboards
            { path: 'admin-dashboard', loadChildren: () => import('app/modules/dashboard/dashboard.routes') },
            { path: 'it-team', loadChildren: () => import('app/modules/dashboard/dashboard.routes') },
            { path: 'dashboard', loadChildren: () => import('app/modules/Account-Manager/dashboard/dashboard.routes') },

            // Attendance
            {
                path: 'attendance', children: [
                    { path: 'attendance-punch-in', loadChildren: () => import('app/modules/attendance/attendance.routes') },
                    { path: 'attendance', loadChildren: () => import('app/modules/attendance/attendance-dashboard/attendance-dashboard.routes') },

                ]
            },
            { path: 'team-attendance', loadComponent: () => import('app/modules/attendance/team-attendance/team-attendance.component').then(m => m.TeamAttendanceComponent) },
            { path: 'team-attendance-view', loadComponent: () => import('app/modules/attendance/team-attendance-view/team-attendance-view.component').then(m => m.TeamAttendanceViewComponent) },
            // Account Manager
            {
                path: 'account-manager', children: [
                    { path: 'payment-details', loadChildren: () => import('app/modules/Account-Manager/payment-details/payment-details.routes') },
                    { path: 'coherent-vendor', loadChildren: () => import('app/modules/Account-Manager/coherent-vendor/coherent-vendor.routes') },
                    { path: 'purchese-invoice', loadChildren: () => import('app/modules/Account-Manager/purchese-invoice/purchese-invoice.routes') },
                    { path: 'coherent-expence', loadChildren: () => import('app/modules/Account-Manager/coherent-expance/coherent-expance.routes') },
                    { path: 'recurring-expence', loadChildren: () => import('app/modules/Account-Manager/recurring-expance/recurring-expance.routes') },
                ]
            },
            // Employee
            {
                path: 'employee', children: [
                    { path: 'employeeList', loadChildren: () => import('app/modules/employee/employee-list/employee-list.routes') },
                    { path: 'employeeCreate', loadChildren: () => import('app/modules/employee/employee-create/employee-create.routes') },
                    { path: 'employeeProfile', loadChildren: () => import('app/modules/employee/employee-profile/employee-profile.routes') },
                    { path: 'employeeView', loadChildren: () => import('app/modules/employee/employee-view/employee-view.routes') },
                    { path: 'employee-inactive-list', loadChildren: () => import('app/modules/employee/inactive-list/inactive-list.routes') },
                    { path: 'employeeDucumentView', loadChildren: () => import('app/modules/employee/employee-document-view/employee-document-view.routes') },
                    { path: 'unMappedEmployeeList', loadChildren: () => import('app/modules/employee/un-mapped-employee/un-mapped-employee.routes') },
                    { path: 'file-Manager', loadChildren: () => import('app/modules/employee/FIle-upload/File-upload.routes') },
                    { path: 'employee-gender-list', loadChildren: () => import('app/modules/employee/employee-gender-list/employee-gender-list.routes') },
                    { path: 'employee-management', loadChildren: () => import('app/modules/employee/employee-management-list/employee-management-list.routes') }
                ]
            },

            // Other modules
            { path: 'user-access', loadChildren: () => import('app/modules/user-access/user-access.routes') },
            { path: 'inventory', loadChildren: () => import('app/modules/inventory/inventory.routes') },
            { path: 'reimbursement', loadChildren: () => import('app/modules/reimbursement/reimbursement.routes') },
            { path: 'coherent-teams', loadChildren: () => import('app/modules/coherent-teams/coherent.teams.routes') },
            { path: 'my-teams', loadChildren: () => import('app/modules/my-teams/my-teams.routes') },
            { path: 'coherent-projects', loadChildren: () => import('app/modules/coherent-projects/coherent-projects.routes') },
            { path: 'trainees', loadChildren: () => import('app/modules/trainees/trainees.routes') },
            { path: 'interview', loadChildren: () => import('app/modules/interview/interview.routes') },
            { path: 'payment-history', loadChildren: () => import('app/modules/finance-manager/payment-history/payment-history.routes') },
            { path: 'client', loadChildren: () => import('app/modules/client/client.routes') },
            { path: 'key-skills', loadChildren: () => import('app/modules/key-skills/key-skills.routes') },
            { path: 'key-skills', loadChildren: () => import('app/modules/key-skills/key-skills.routes') },
            { path: 'my-projects', loadChildren: () => import('app/modules/my-projects/my-projects.routes') },
            { path: 'recruitment', loadChildren: () => import('app/modules/recruitment/recruitment.routes') },
            { path: 'license-management', loadChildren: () => import('app/modules/license-management/licence-management.routes') },

            // Master Data
            {
                path: 'masterdata', children: [
                    { path: 'clients', loadChildren: () => import('app/modules/masterData/Clients/Clients.routes') },
                    { path: 'project', loadChildren: () => import('app/modules/masterData/Project/Project.routes') },
                    { path: 'team-mapping', loadChildren: () => import('app/modules/masterData/Team-Mapping/Team-Mapping.routes') },
                    { path: 'holiday', component: HolidaysComponent },
                ]
            },
            {
                path: 'branch-management',
                children: [
                    {
                        path: '',
                        loadChildren: () => import('app/modules/branch-management/branch-management.routes'),
                    },
                    {
                        path: 'cbe',
                        loadChildren: () => import('app/modules/branch-management/cbe-branch/cbe-branch.routs'),
                    },
                    {
                        path: 'chn',
                        loadChildren: () => import('app/modules/branch-management/chn-branch/chn-branch.routs')
                    }
                ]
            },

            // Pages
            {
                path: 'pages', children: [
                    // Error
                    {
                        path: 'error', children: [
                            { path: '404', loadChildren: () => import('app/modules/admin/pages/error/error-404/error-404.routes') },
                            { path: '500', loadChildren: () => import('app/modules/admin/pages/error/error-500/error-500.routes') }
                        ]
                    },
                    // Maintenance
                    { path: 'maintenance', loadChildren: () => import('app/modules/admin/pages/maintenance/maintenance.routes') },
                ]
            },

            // 404 & Catch all
            { path: '404-not-found', pathMatch: 'full', loadChildren: () => import('app/modules/admin/pages/error/error-404/error-404.routes') },
            { path: '**', redirectTo: '404-not-found' }
        ]
    }
];
